import React from 'react';
import { useEmulators } from '../../firebase';
import '../../assets/styles/scss/components/EmulatorBanner.scss';

/**
 * EmulatorBanner - Visual indicator when running in emulator mode
 * 
 * Displays a prominent banner at the top of the screen to clearly indicate
 * the app is connected to Firebase Emulators (not production data).
 * 
 * Only shows when REACT_APP_USE_EMULATORS=true
 */
const EmulatorBanner = () => {
  if (!useEmulators) {
    return null;
  }

  return (
    <div className="emulator-banner">
      <div className="emulator-banner__content">
        <span className="emulator-banner__text">
          <strong>EMULATOR MODE</strong>
          <span className="emulator-banner__subtext">
            Auth: :9099 | Firestore: :8080 | Functions: :5001
          </span>
        </span>
        <a 
          href="http://localhost:4000" 
          target="_blank" 
          rel="noopener noreferrer"
          className="emulator-banner__link"
        >
          Emulator UI →
        </a>
      </div>
    </div>
  );
};

export default EmulatorBanner;
